
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import AddProductForm from './pages/AddProductForm';
import ProductDetailPage from './pages/ProductDetailPage';
import CheckID from './pages/CheckID';
import Products from './pages/Products';

function App() {
  function ProtectedRoute({ children }) {
    const token = localStorage.getItem("token");
    
    return token ? children : <Navigate to="/login" />;
  }

  return (
    <Routes>
      
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/product/new" element={<ProtectedRoute><AddProductForm /></ProtectedRoute>} />
      <Route path="/product/:id" element={<ProtectedRoute><ProductDetailPage /></ProtectedRoute>} />
      <Route path="/scan/:qr_id" element={<ProtectedRoute><CheckID /></ProtectedRoute>} />
      <Route path='products' element={<ProtectedRoute><Products /></ProtectedRoute>} />
    </Routes>
  );
}

export default App;
